// @flow
import normalizeStringForSearch from './normalizeStringForSearch';
import type { DataEntry } from './types';

const numberFormatter = new Intl.NumberFormat('en-US', { currency: 'USD' });
const formatAsUSD = amountInCents => numberFormatter.format(amountInCents / 100);

const doesDataEntryContainSearchString = (dataEntry: DataEntry, search: string): boolean => {
  const searchString = normalizeStringForSearch(search);
  const {
    amountInCents,
    journalEntry: { categorization, clientComments, internalNotes, vendorName, clientCatResponse },
  } = dataEntry;
  if (normalizeStringForSearch(vendorName).includes(searchString)) {
    return true;
  }
  if (
    categorization &&
    normalizeStringForSearch(categorization.categorizationUIClientComment).includes(searchString)
  ) {
    return true;
  }
  if (clientCatResponse && normalizeStringForSearch(clientCatResponse).includes(searchString)) {
    return true;
  }
  if (
    internalNotes &&
    internalNotes.some(({ body }) => normalizeStringForSearch(body).includes(searchString))
  ) {
    return true;
  }
  if (
    clientComments &&
    clientComments.some(({ body }) => normalizeStringForSearch(body).includes(searchString))
  ) {
    return true;
  }
  if (String(amountInCents).includes(searchString)) {
    return true;
  }
  const decimalStringAmount = (dataEntry.amountInCents / 100).toFixed(2);
  if (decimalStringAmount.includes(searchString)) {
    return true;
  }
  const dollarAmountString = formatAsUSD(dataEntry.amountInCents);
  if (dollarAmountString.includes(searchString)) {
    return true;
  }
  // All the searches above failed to locate the search string
  return false;
};

export default doesDataEntryContainSearchString;
